import { useMutation } from '@tanstack/react-query';
import { UseMutationOptions } from '@tanstack/react-query';
import { logger } from '@/utils';
import { usersQueryKeys } from '../data';
import { uploadCsv } from '../api';

export const useUploadCSVMutation = (
  options: Partial<UseMutationOptions<any, any, { file: File }>> = {}
) => {
  return useMutation({
    mutationKey: usersQueryKeys.uploadCsv,
    mutationFn: uploadCsv,
    onSuccess: (...args) => {
      logger.log(args[0]);
      if (options.onSuccess) {
        options.onSuccess(...args);
      }
    },
    onError: (...args) => {
      logger.log(args[0]);
      if (options.onError) {
        options.onError(...args);
      }
    },
    ...options,
  });
};
